import type { RegionsTranslation } from './types'

/**
 * Urdu translations for Regions domain
 */
export const regionsTranslationUr: RegionsTranslation = {
  // Page/Section level
  title: 'علاقے',
  subtitle: 'جغرافیائی علاقوں اور ان کی فیکٹری تفویض کا انتظام کریں',

  // Actions
  addRegion: 'علاقہ شامل کریں',
  editRegion: 'علاقے میں ترمیم کریں',
  deleteRegion: 'علاقہ حذف کریں',

  // Drawer Headers
  addRegionDescription: 'نیا علاقہ بنانے کے لیے تفصیلات بھریں',
  editRegionDescription: 'نیچے علاقے کی تفصیلات اپ ڈیٹ کریں',
  viewRegionDescription: 'علاقے کی معلومات اور تفویضات دیکھیں',

  // Search and states
  searchPlaceholder: 'علاقے تلاش کریں...',
  noRegions: 'کوئی علاقہ نہیں ملا',
  noRegionsDescription:
    'ابھی تک کوئی علاقہ ترتیب نہیں دیا گیا۔ جغرافیائی علاقوں کا انتظام شروع کرنے کے لیے اپنا پہلا علاقہ شامل کریں۔',
  addFirst: 'اپنا پہلا علاقہ شامل کریں',

  // Form fields
  code: 'علاقے کا کوڈ',
  codePlaceholder: 'مثال: CENTRAL، EASTERN',
  name: 'علاقے کا نام',
  namePlaceholder: 'مثال: مرکزی علاقہ',
  description: 'تفصیل',
  descriptionPlaceholder: 'علاقے کی تفصیل درج کریں (اختیاری)',
  country: 'ملک',
  selectCountry: 'ملک منتخب کریں',
  factories: 'تفویض شدہ فیکٹریاں',
  selectFactories: 'تفویض کے لیے فیکٹریاں منتخب کریں',
  noFactoriesSelected: 'کوئی فیکٹری تفویض نہیں ہے',
  status: 'حالت',

  // Status values
  active: 'فعال',
  inactive: 'غیر فعال',
  all: 'تمام',

  // Stats
  totalRegions: 'کل علاقے',
  activeRegions: 'فعال',
  inactiveRegions: 'غیر فعال',
  factoriesCount: 'فیکٹریاں',
  citiesCount: 'شہر',

  // Table headers
  table: {
    code: 'کوڈ',
    name: 'نام',
    country: 'ملک',
    factories: 'فیکٹریاں',
    cities: 'شہر',
    status: 'حالت',
    actions: 'اعمال',
  },

  // Card content
  card: {
    factories: 'فیکٹریاں',
    cities: 'شہر',
    noFactories: 'کوئی فیکٹری تفویض نہیں ہے',
    noCities: 'کوئی شہر منسلک نہیں ہے',
  },

  // Messages
  messages: {
    createSuccess: 'علاقہ بنایا گیا',
    createSuccessDescription: 'نیا علاقہ کامیابی سے بنایا گیا ہے۔',
    updateSuccess: 'علاقہ اپ ڈیٹ ہوا',
    updateSuccessDescription: 'علاقہ کامیابی سے اپ ڈیٹ ہو گیا ہے۔',
    deleteSuccess: 'علاقہ حذف ہوا',
    deleteSuccessDescription: 'علاقہ ہٹا دیا گیا ہے۔',
    deleteConfirm: 'علاقہ حذف کریں',
    deleteConfirmDescription:
      'کیا آپ واقعی اس علاقے کو حذف کرنا چاہتے ہیں؟ یہ کسٹمر ایڈریس کی پابندیوں کو متاثر کر سکتا ہے۔',
    loadError: 'علاقے لوڈ کرنے میں ناکامی۔ براہ کرم دوبارہ کوشش کریں۔',
  },

  // Validation
  validation: {
    codeRequired: 'علاقے کا کوڈ درکار ہے',
    codeInvalid: 'علاقے کا کوڈ الفانیومرک اور بڑے حروف میں ہونا چاہیے',
    nameRequired: 'علاقے کا نام درکار ہے',
  },

  // Filter
  filter: {
    all: 'تمام حالت',
    active: 'صرف فعال',
    inactive: 'صرف غیر فعال',
    byCountry: 'ملک کے مطابق فلٹر کریں',
  },
}
